import { ObservationsMapTimeSeriesSection } from "./observations-map-time-series-section";

export function ObservationsMapTimeSeriesTab() {
  return <ObservationsMapTimeSeriesSection />;
}
